import React from "react";
import { useTranslation } from "react-i18next";
import { ColorV2 } from "config/colors";
import { CustomIcon } from "components/icon/customIcon.component";
import {
  WorkerCounterControls,
  WorkerCounterLabel,
  WorkerCounterValue,
  WorkerCounterWrapper,
} from "./workerCounter.styled";

type Props = {
  value: number;
  onChange: (value: number) => void;
  label?: string;
};

export const WorkerCounter: React.FC<Props> = ({ value, onChange, label }) => {
  const { t } = useTranslation();

  return (
    <WorkerCounterWrapper>
      <WorkerCounterLabel>
        {label ?? t("CreateShift.WorkersNeeded")}
      </WorkerCounterLabel>
      <WorkerCounterControls>
        <CustomIcon
          name="minus"
          color={ColorV2.Blue4}
          backgroundColor={ColorV2.Blue6}
          padding="6px"
          onClick={() => {
            if (value > 1) onChange(value - 1);
          }}
        />
        <WorkerCounterValue>{value}</WorkerCounterValue>
        <CustomIcon
          name="plus_old"
          color={ColorV2.White}
          backgroundColor={ColorV2.Blue1}
          padding="6px"
          onClick={() => {
            onChange(value + 1);
          }}
        />
      </WorkerCounterControls>
    </WorkerCounterWrapper>
  );
};
